import React from "react";
import styled, { keyframes } from "styled-components";

// Define the animation
const loadingAnimation = keyframes`
  0% { left: 0; }
  100% { left: 100%; }
`;

// Styled loading bar container
const LoadingBar = styled.div`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '40px'};
  margin: ${props => props.margin || '0'};
  background-color: #ededed;
  position: relative;
  overflow: hidden;
`;

// Styled animated bar
const AnimatedBar = styled.div`
  position: absolute;
  height: 100%;
  width: 10%;
  background: linear-gradient(to right, #fff, #fff);
  animation: ${loadingAnimation} 2s infinite;
  transform: skewX(-10deg);
  filter: blur(20px);
`;

const LoadingEffect = (props) => {
  const {width, height, margin} = props;
  return (
    <LoadingBar margin={margin} height={height} width={width || '100%'}>
      <AnimatedBar />
    </LoadingBar>
  );
};

export default LoadingEffect;
